module.exports = require("request");


//////////////////
// WEBPACK FOOTER
// external "request"
// module id = 7
// module chunks = 0